
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graduates/[slug]",
      function () {
        return require("private-next-pages/graduates/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graduates/[slug]"])
      });
    }
  